import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Grid,
  IconButton,
  Paper,
  Switch,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { Adjust, Delete, Launch, Visibility } from "@mui/icons-material";
import {
  DataGrid,
  GridToolbar,
  GridFilterModel,
  GridRowsProp,
  GridCellParams,
  GridColumnVisibilityModel,
  GridColDef,
} from "@mui/x-data-grid";

interface Event {
  id: number;
  name: string;
  category: {
    id: number;
    name: string;
  };
  startDate: string;
  endDate: string;
  isPublished: boolean;
  status: string;
}

interface PlannerEventsTableProps {
  events: Event[];
  selectEvent: React.Dispatch<React.SetStateAction<Event | undefined>>;
}

export const PlannerEventsTable = ({
  events,
  selectEvent,
}: PlannerEventsTableProps) => {
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [""],
  });
  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({});

  /* BOTON ENCARGADO DE CAMBIAR EL ESTADO, AUNQUE ESTO VA OUT */
  const handleToggleState = async (id: any, checked: any) => {
    // Lógica para manejar el cambio de estado aquí
    console.log(`Cambiando estado para ID ${id}: ${checked}`);
  };

  const columns: GridColDef[] = [


    { field: "name", headerName: "Nombre", width: 200 },

    {
      field: "category",
      headerName: "categoria",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "startDate",
      headerName: "fecha",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    /*     {
          field: "ingresos",
          headerName: "ingresos",
          width: 150,
          headerAlign: "center",
          align: "center",
        }, */

    {
      field: "status",
      headerName: "Estado",
      width: 100,
      type: "string",
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridCellParams) => (
        <Switch
          checked={params.value === "activo"}
          onChange={(event) =>
            handleToggleState(params.id, event.target.checked)
          }
          color="primary"
        />
      ),
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <IconButton sx={{ backgroundColor: "warning.main", borderRadius: "6px", padding: 0.5, color: "#292929", marginRight: 1 }}
           
            onClick={() => selectEvent(params.row)}>
            <Visibility />
          </IconButton>

          <IconButton sx={{ backgroundColor: "error.main", borderRadius: "6px", padding: 0.5, color: "#292929" }}
            color="secondary"
          // onClick={() => handleOpenDeleteDialog(params.id)}
          >
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];
  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const rows: GridRowsProp = events.map((event) => ({
    id: event.id,
    name: event.name,
    startDate: formatDate(event.startDate),
    category: event.category.name,
    ingresos: "N/A",
    status: event.status,
  }));

  return (
    <Paper
      sx={{ overflow: "hidden", width: "100%", borderRadius: 2, mt: 3, p: 2 }}
      elevation={6}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Grid item>
          <Typography
            fontSize={32}

            component="div"
            align="left"
          >
            Organizados por mí
          </Typography>
        </Grid>
        <Grid item>
          <Button
            component={RouterLink}
            to={"/planner/events/create"}
            variant="contained"
            sx={{ ml: 0, bgcolor: "primary.light" }}
          >
            Crear evento
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ height: "65vh" }}>
        <DataGrid
          columns={columns}
          rows={rows}
          slots={{ toolbar: GridToolbar }}
          filterModel={filterModel}
          localeText={{
            noRowsLabel: "No hay filas",
            noResultsOverlayLabel: "No se encontraron resultados.",
            toolbarColumns: "Columnas",
            toolbarColumnsLabel: "Selecciona columnas",
            toolbarFilters: "Filtros",
            toolbarFiltersLabel: "Mostrar filtros",
            toolbarFiltersTooltipHide: "Ocultar filtros",
            toolbarFiltersTooltipShow: "Mostrar filtros",
            filterPanelAddFilter: "Agregar filtro",
            filterPanelRemoveAll: "Eliminar todos",
            filterPanelDeleteIconLabel: "Eliminar",
            filterPanelLogicOperator: "Operador lógico",
            filterPanelOperatorAnd: "Y",
            filterPanelOperatorOr: "O",
            filterPanelColumns: "Columnas",
            filterPanelInputLabel: "Valor",
            filterPanelOperator: "Operador",
            filterPanelInputPlaceholder: "Filtrar valor",
            toolbarQuickFilterPlaceholder: "Buscar",
            toolbarExport: "Exportar",
            toolbarExportLabel: "Exportar",
            toolbarExportCSV: "Descargar como CSV",
            toolbarExportPrint: "Imprimir",
            toolbarDensity: "Densidad",
            toolbarDensityLabel: "Densidad",
            toolbarDensityCompact: "Compacta",
            toolbarDensityStandard: "Estándar",
            toolbarDensityComfortable: "Cómoda",
            columnMenuLabel: "Menú",
            columnMenuShowColumns: "Mostrar columnas",
            columnMenuFilter: "Filtrar",
            columnMenuHideColumn: "Ocultar",
            columnMenuUnsort: "Desordenar",
            columnMenuSortAsc: "Orden ascendente",
            columnMenuSortDesc: "Orden descendente",
          }}
          onFilterModelChange={(newModel) => setFilterModel(newModel)}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
        />
      </Box>
    </Paper>
  );
};


